import React from 'react';
import { Title, Text, Button, Group } from '@mantine/core';
import { GrantMeContainer } from '../../layout/GrantMeContainer';
import { createStyles } from '@mantine/emotion';

const useStyles = createStyles((theme, _, u) => ({
  root: {
    paddingTop: 80,
    paddingBottom: 80,
  },

  label: {
    textAlign: 'center',
    fontWeight: 900,
    fontSize: 220,
    lineHeight: 1,
    // marginBottom: theme.spacing.xl * 1.5,
    marginBottom: 32 * 1.5, //XL = 32
    color: theme.colors.gray[2],

    [u.smallerThan('sm')]: {
      fontSize: 120,
    },
  },

  title: {
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,
    textAlign: 'center',
    fontWeight: 900,
    fontSize: 38,

    [u.smallerThan('sm')]: {
      fontSize: 32,
    },
  },

  description: {
    maxWidth: 500,
    margin: 'auto',
    marginTop: theme.spacing.xl,
    // marginBottom: theme.spacing.xl * 1.5,
    marginBottom: 32 * 1.5, //XL = 32
  },
}));

export const PageNotFoundView = () => {
  const { classes } = useStyles();

  return (
    <GrantMeContainer className={classes.root}>
      <div className={classes.label}>404</div>
      <Title className={classes.title}>You have found a secret place.</Title>
      <Text c="dimmed" size="lg" ta="center" className={classes.description}>
        Unfortunately, this is only a 404 page. You may have mistyped the address, or the page has
        been moved to another URL.
      </Text>
      <Group justify="center">
        <Button variant="subtle" size="md">
          Take me back to home page
        </Button>
      </Group>
    </GrantMeContainer>
  );
};
